import PropTypes from 'prop-types'
import { useState, useContext, useEffect, useCallback } from 'react'
import { useLocation } from 'react-router-dom'
import ContenedorDetalle from './ContenedorDetalle'
import ContenedorMenu from './ContenedorMenu'
import ContenedorPrincipal from './ContenedorPrincipal'
import { LoginContext } from './context/loginContext'
import withEsMovil from './hoc/withEsMovil'

const Cuerpo = ({ mostrarAyuda, cambiarImagenPerfil }) => {
  const [entidad, setEntidad] = useState(null)
  const [id, setId] = useState(0)
  const [idAnterior, setIdAnterior] = useState(0)
  const [verDetalle, setVerDetalle] = useState(false)
  const location = useLocation()
  const { isAuthenticated } = useContext(LoginContext)
  const [actualizarPantalla, setActualizarPantalla] = useState(false)
  const [actualizarPantallaDetalle, setActualizarPantallaDetalle] = useState(false)

  const handleCerrarDetalle = useCallback(() => {
    setVerDetalle(false)
  }, [])

  useEffect(() => {
    // Reset detail view when navigating to routes that don't support details
    setEntidad(null)
    setId(0)
    setIdAnterior(0)
    setVerDetalle(false)
  }, [location])

  useEffect(() => {
    handleCerrarDetalle()
  }, [handleCerrarDetalle])

  const handleToggle = (event, entidad, id) => {
    const shouldShowDetalle = !verDetalle || id !== idAnterior ? true : false
    setEntidad(entidad)
    setId(id)
    setIdAnterior(id)
    setVerDetalle(shouldShowDetalle)
  }

  const handleActualizarPantalla = () => {
    setActualizarPantalla(true)
    setTimeout(() => setActualizarPantalla(false), 0)
  }

  const handleActualizarPantallaDetalle = () => {
    setActualizarPantallaDetalle(true)
    setTimeout(() => setActualizarPantallaDetalle(false), 0)
  }

  return (
    <>
      {location.pathname.indexOf('Login') === -1 && isAuthenticated && (
        <div>
          <ContenedorMenu mostrarAyuda={mostrarAyuda} />
        </div>
      )}
      {
        <div
          className="main-content-container"
          style={{
            boxSizing: 'border-box', // Include padding in width calculation
            maxWidth: '100%', // Ensure it never exceeds viewport width
            width: '100vw',
            padding: '0 5vw'
          }}
        >
          {verDetalle ? (
            <ContenedorDetalle
              entidad={entidad}
              onCerrarClick={handleCerrarDetalle}
              onActualizarPantalla={handleActualizarPantalla}
              actualizarPantallaDetalle={actualizarPantallaDetalle}
              idPublicacion={id}
            />
          ) : (
            <ContenedorPrincipal
              onToggleClick={handleToggle}
              actualizarPantalla={actualizarPantalla}
              onActualizarPantallaDetalle={handleActualizarPantallaDetalle}
              cambiarImagenPerfil={cambiarImagenPerfil}
            />
          )}
        </div>
      }
    </>
  )
}

Cuerpo.propTypes = {
  mostrarAyuda: PropTypes.func,
  cambiarImagenPerfil: PropTypes.func
}

export default withEsMovil(Cuerpo)
